import React from 'react';
import { ArticleHeading2, ArticleParagraph1, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

import { NBSP } from 'shared/constants/common';
import { TCalculatorMcfErrorsItem } from 'shared/types/features';
import { BankLogoList } from '../BankLogoList';

import styles from './styles.css';
import { ETestIds } from '../../constants/testIds';

interface IMortgageOfferValidationProps {
  errors: TCalculatorMcfErrorsItem[];
  bankList: string[];
}

export const MortgageOfferValidation: React.FC<IMortgageOfferValidationProps> = props => {
  const { errors, bankList } = props;

  function scrollToField(fieldName: string) {
    const $field = document.querySelector(`input[name=${fieldName}]`) as HTMLInputElement;
    $field?.focus();
    $field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <div
      data-testid={ETestIds.MortgageOfferValidation}
      className={cn(styles['wrapper'], isDesktop && styles['desktop'])}
    >
      <ArticleHeading2>
        Настройте{NBSP}калькулятор — покажем{NBSP}предложения
      </ArticleHeading2>
      <div data-testid={ETestIds.MortgageOfferValidationMessage} className={styles['message']}>
        <ArticleParagraph1>
          Укажите{NBSP}
          {errors.map((el, index) => {
            return (
              <span key={index} className={styles['field']} onClick={() => scrollToField(el.field)}>
                {el.label}
              </span>
            );
          })}
        </ArticleParagraph1>
      </div>

      <BankLogoList banks={bankList} />
    </div>
  );
};
